import React from 'react'

export const TripAdvisorConversionPixel = ({ refId }) => (
  <img src={`https://www.tripadvisor.com/CommPT?partner=sevenrooms&refid=${encodeURIComponent(refId)}`} />
)
